<template>
  <v-app>
    <v-main>
      <v-container class="fill-height" fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="8" md="6" lg="4">
            <v-card class="elevation-12">
              <v-toolbar color="primary" dark flat>
                <v-toolbar-title>{{ $t("login.login") }}</v-toolbar-title>
                <v-spacer />

                <v-btn dark icon class="mx-8" :to="`/${$i18n.locale}/serviceapp`">
                  Service
                  <v-icon>mdi-developer-board</v-icon>
                </v-btn>
                <AccountMenu :loginScreen="true" />
              </v-toolbar>

              <v-card-text>
                <form @submit.prevent="submit">
                  <!--  @keydown="onKeyDown" -->

                  <!--                  
                  :rules="userRules"
                  :rules="passwordRules" 
                  -->
                  <v-text-field v-model="username" :label="$t('login.user')" :error-messages="nameVuelidate()" required> </v-text-field>
                  <v-text-field v-model="password" :label="$t('login.pw')" :error-messages="passwordVuelidate()" required :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'" :type="show ? 'text' : 'password'" @click:append="show = !show"> </v-text-field>

                  {{ $t("login.IP") }}

                  <v-combobox id="myRefUrls" ref="myRefUrls" @input.native="(e) => (url = e.target.value)" menu-props="auto, overflowY" v-model="url" :items="filteredUrls" :label="$t('login.url')" dense filled solo outlined required :error-messages="urlVuelidate()"></v-combobox>

                  <template v-if="submitStatus === 'ERROR'">
                    <v-alert border="top" color="red" elevation="4" type="error"> {{ this.$t("login.submit.error") }}</v-alert>
                  </template>

                  <template v-else-if="alert.type == 'error' && alert.message">
                    <v-alert border="top" color="red" elevation="4" type="error"> {{ alert.message }}</v-alert>
                  </template>

                  <template v-else-if="submitStatus === 'PENDING'">
                    <v-alert border="top" color="yellow" elevation="4" type="info"> {{ this.$t("login.submit.pending") }}</v-alert>
                  </template>

                  <v-checkbox class="ml-2" v-model="rememberMe" :label="$t('login.rememberMe')"></v-checkbox>
                  <v-row no-gutters>
                    <v-col cols="6" align="center">
                      <v-menu v-model="menu" :close-on-content-click="false" :nudge-width="200" offset-x>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn color="primary" dark v-bind="attrs" v-on="on"> {{ $t("login.editURL") }} </v-btn>
                        </template>

                        <v-card>
                          <v-list>
                            <v-list-item v-for="(item, index) in urls" :key="index">
                              <v-list-item-title>{{ item }}</v-list-item-title>
                              <v-list-item-action>
                                <v-btn icon color="red">
                                  <v-icon @click="editURLs(item, index)"> mdi-delete-empty </v-icon>
                                </v-btn>
                              </v-list-item-action>
                            </v-list-item>
                          </v-list>
                        </v-card>
                      </v-menu>
                    </v-col>

                    <v-col cols="6" align="center">
                      <v-btn @click="handleSubmit" :disabled="submitStatus === 'PENDING'" color="primary" dark>{{ $t("login.login") }}</v-btn>
                    </v-col>
                  </v-row>
                </form>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <template v-if="vuexApp.name == 'EnergyCloud'">
          <v-row class="ma-4" dense justify="space-around">
            <v-col cols="12" md="auto" align="space-around">
              <a href="https://my.energycloud.cz/registration" target="_blank" class="text-overline">{{ $t("login.register") }}</a>
            </v-col>

            <v-col cols="12" md="auto" align="space-around">
              <a href="https://my.energycloud.cz/passwordrecovery" target="_blank" class="text-overline">{{ $t("login.passwordRecovery") }}</a>
            </v-col>

            <v-col cols="12" md="auto" align="space-around">
              <a href="https://www.energycloud.cz/en/ecapp-privacy-policy" target="_blank" style="color: green" class="text-overline">{{ $t("login.privacyPolicy") }}</a>
            </v-col>

            <v-col cols="12" md="auto" align="space-around">
              <a href="https://static.energycloud.cz/ECApp-UzivatelskyManual.pdf" target="_blank" style="color: orange" class="text-overline">{{ $t("support.userGuide") }}</a>
            </v-col>

            <v-col cols="12" md="auto" align="space-around">
              <a href="https://my.energycloud.cz/deleteaccount" target="_blank" style="color: red" class="text-overline">{{ $t("login.deleteAccount") }}</a>
            </v-col>
          </v-row>
          <!--           
          <template v-if="$vuetify.breakpoint.smAndDown">
            <v-row dense>
              <v-col cols="12">
                <v-btn x-small text color="primary" :disabled="true">
                  <a>{{ $t("login.checkUpdates") }}: </a>
                </v-btn>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12" md="1">
                <v-btn x-small text color="primary">
                  ->&nbsp; <a href="https://play.google.com/store/apps/details?id=cz.energycloud.home" target="_blank">{{ $t("login.checkUpdateGoogle") }}</a>
                  &nbsp;<-
                </v-btn>
              </v-col>
              <v-col cols="12" md="1">
                <v-btn x-small text color="primary">
                  ->&nbsp; <a href="https://apps.apple.com/us/app/energycloud-home/id1535173110" target="_blank">{{ $t("login.checkUpdateApple") }}</a>
                  &nbsp;<-
                </v-btn>
              </v-col>
            </v-row>
          </template> 
          -->
        </template>

        <v-row dense>
          <v-col cols="12" sm="1" align="start">
            <v-btn x-small text color="primary" disabled> build: {{ vuexApp.build }} </v-btn>
          </v-col>
        </v-row>

        <!--         <template v-if="vuexApp.name == 'EnergyCloud'">
          <template v-if="snackbar === true">
            <v-row align="end" justify="end">
              <v-snackbar class="mt-2" v-model="snackbar" :dark="$vuetify.theme.dark" :timeout="-1" color="primary" :vertical="true">
                <a href="https://www.energycloud.cz/en/ecapp-privacy-policy/" target="_blank" class="white--text d-block">{{ $t("login.cookies1") }} {{ $t("login.cookies2") }} {{ $t("login.cookies3") }}</a>
                <template v-slot:action="{ attrs }">
                  <v-btn color="white" text v-bind="attrs" @click="snackbarCookies()">
                    {{ $t("login.closeCookies") }}
                  </v-btn>
                </template>
              </v-snackbar>
            </v-row>
          </template>
        </template> -->
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
/*eslint no-unused-vars: ["error", { "args": "none" }]*/

import { validationMixin } from "vuelidate";

import { required, minLength, maxLength } from "vuelidate/lib/validators";

import { mapState, mapActions } from "vuex";

import AccountMenu from "../../components/account/AccountMenu.vue";

export default {
  mixins: [validationMixin],
  validations: {
    username: {
      required,
      maxLength: maxLength(30),
      minLength: minLength(3),
    },
    password: {
      required,
      maxLength: maxLength(30),
      minLength: minLength(2),
    },
    url: {
      required,
      minLength: minLength(4),
    },
  },
  data: () => ({
    currentTargetInput: null,
    submitStatus: null,

    username: "",
    password: "",
    url: "",
    urls: [],

    /* timer: null, */

    /*
    userRules: [
      (v) => !!v || "Username is required", //
      (v) => /^[a-zA-Z0-9\S]*$/.test(v) || "Only letters and numbers are allowed", //
      (v) => v.length >= 3 || "Username must be at least 3 characters long", //
    ],
    passwordRules: [
      (v) => !!v || "Password is required", //
      (v) => /^[a-zA-Z0-9\S]*$/.test(v) || "Only letters and numbers are allowed", //
      (v) => v.length >= 3 || "Password must be at least 3 characters long", //
    ],
    */

    menu: 0,

    valid: true,

    autoLogin: false,
    rememberMe: false,

    serverIP: "",
    show: false,

    //snackbar: true,
  }),

  components: {
    AccountMenu,
  },
  computed: {
    ...mapState("account", ["status"]),
    ...mapState({
      alert: (state) => state.alert,
      vuexApp: (state) => state.app,
    }),
    filteredUrls() {
      if (this.url === null || this.url === "") {
        return this.urls;
      } else {
        return this.urls.filter((u) => u.toLowerCase().includes(this.url.toLowerCase()));
      }
    },
  },
  created() {
    this.logout();

    /*
    this.timer = setInterval(() => {
      console.log(this.$refs.myRefUrls);
      console.log("lazySearch", this.$refs.myRefUrls.lazySearch);
      console.log("lazyValue", this.$refs.myRefUrls.lazyValue);
      console.log("selectedIndex", this.$refs.myRefUrls.selectedIndex);
      console.log("isMenuActive", this.$refs.myRefUrls.isMenuActive);
      console.log("isFocused", this.$refs.myRefUrls.isFocused);
      console.log("isActive", this.$refs.myRefUrls.isActive); 
    }, 1000);
    */
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("keyup", this.onKeyUp);
    });

    this.loadSettings();

    if (this.rememberMe) {
      this.handleSubmit();
    }
  },
  methods: {
    ...mapActions("account", ["login", "logout"]),
    ...mapActions({
      clearAlert: "alert/clear",
      vuexUpdatePointType: "point/updateType",
      vuexUpdatePointProjectName: "point/updateProjectName",
      vuexUpdatePointObjectName: "point/updateObjectName",
      vuexUpdatePointSerialNumber: "point/updateSerialNumber",
    }),
    onKeyUp(event) {
      let name = event.key;

      if (name === "Enter") {
        /* if (this.$refs.myRefUrls.isFocused === true) { */
        this.$refs.myRefUrls.focus();
        /* } */

        // Cross-browser solution
        if (this.$refs.myRefUrls.isMenuActive === true) {
          this.$refs.myRefUrls.blur();
        }

        // this.url = this.$refs.myRefUrls.lazySearch;
        /* 
        this.$refs.myRefUrls.setSearch(this.$refs.myRefUrls.lazySearch);
        this.$refs.myRefUrls.setValue(this.$refs.myRefUrls.lazySearch); */

        // Manually trigger the input value handling
        /*         const inputValue = this.$refs.myRefUrls.lazySearch; // or use v-model's bound data
        console.log("User input value:", inputValue); */

        this.handleSubmit();
      }
    },
    /*     onKeyDown(event) {
      if (event.key === "Enter") {
        this.handleSubmit();
      }
    }, */
    nameVuelidate() {
      if (!this.$v.username.required) {
        return this.$t("login.rules.username");
      } else if (!this.$v.username.maxLength || !this.$v.username.minLength) {
        return this.$t("login.rules.usernameLen");
      }
    },
    passwordVuelidate() {
      if (!this.$v.password.required) {
        return this.$t("login.rules.password");
      } else if (!this.$v.password.maxLength || !this.$v.password.minLength) {
        return this.$t("login.rules.passwordLen");
      }
    },
    urlVuelidate() {
      if (!this.$v.url.required) {
        return this.$t("login.rules.address");
      }
    },
    editURLs(item, index) {
      let array = [];

      for (let i = 0; i < this.urls.length; i++) {
        /* console.log(i); */

        if (i !== index) {
          /* console.log("pushing", this.urls[i]); */
          array.push(this.urls[i]);
        }
      }

      this.urls = [];

      this.urls = array;

      var loginObject = {
        username: this.username,
        password: this.password,
        url: this.url,
        autoLogin: this.rememberMe,
      };

      localStorage.setItem("login", JSON.stringify(loginObject));

      localStorage.setItem("urls", JSON.stringify(this.urls));
      localStorage.setItem("url", this.url);
    },
    clearLocalStorage() {
      localStorage.clear();

      this.clearAlert();

      this.username = "";
      this.password = "";
      this.serverIP = "";
      this.url = "";
      this.urls = [];
    },
    saveSettings() {
      var loginObject = {
        username: this.username,
        password: this.password,
        url: this.url,
        autoLogin: this.rememberMe,
      };
      localStorage.setItem("login", JSON.stringify(loginObject));

      if (this.url != null || this.url != "") {
        if (this.urls.includes(this.url) == false) {
          this.urls.push(this.url);
        }

        localStorage.setItem("urls", JSON.stringify(this.urls));
        localStorage.setItem("url", this.url);
      }
    },
    loadSettings() {
      /* if (localStorage.getItem("cookies") !== null) {
        this.snackbar = localStorage.getItem("cookies") == "false" ? false : true;
      } */
      if (localStorage.getItem("urls") !== null) {
        this.urls = JSON.parse(localStorage.getItem("urls"));
      }
      if (localStorage.getItem("url") !== null) {
        this.url = localStorage.getItem("url");
      }

      if (localStorage.login) {
        var retrievedObject = JSON.parse(localStorage.getItem("login"));
        this.rememberMe = retrievedObject.autoLogin;
        this.username = retrievedObject.username;
        this.password = retrievedObject.password;
        this.url = retrievedObject.url;
      }
    },
    validateUrl(url) {
      let regexIP = /\b(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\b/g;
      //eslint-disable-next-line
      let regexIPWithPort = /(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\:([0-9])/gi;

      url = url.toLowerCase();

      if (url.search(regexIP) != -1) {
        // IP address entered

        if (url.search("https://") == -1 && url.search("http://") == -1) {
          // 'https://' and 'http://' not found in URL...
          url = "http://" + url;
        } else if (url.search("https://") != -1) {
          // 'http://' not found, but 'https://' found
          url = url.replace("https://", "http://");
        }
        if (url.search(regexIPWithPort) == -1) {
          // No port entered
          url = url + ":8082";
        }
      } else {
        // Domain entered

        if (url.search("iqhouse.cz") != -1 || url.search("energycloud.cz") != -1) {
          // found 'iqhouse.cz'
          if (url.search("http://") == -1 && url.search("https://") == -1) {
            // 'https://' and 'http://' not found in URL...
            url = "https://" + url;
          } else if (url.search("http://") != -1) {
            // 'https://' not found, but 'http://' found
            url = url.replace("http://", "https://");
          }
        } else if (url.search("inverter.local") != -1) {
          // found 'inverter.local'
          if (url.search("http://") == -1 && url.search("https://") == -1) {
            url = "http://" + url;
          } else if (url.search("https://") != -1) {
            url = url.replace("https://", "http://");
          }
          if (url.search(":8082") == -1) {
            url = url + ":8082";
          }
        }
      }

      return url;
    },
    handleSubmit() {
      this.username = this.username.trim();
      this.password = this.password.trim();
      this.url = this.url.trim();

      this.clearAlert();

      this.$v.$touch();
      if (this.$v.$invalid) {
        this.submitStatus = "ERROR";
      } else {
        this.serverIP = this.validateUrl(this.url);
        this.url = this.serverIP;

        this.saveSettings();

        this.serverIP = this.serverIP + "/rest/ecapp/login.json";

        this.submitStatus = "PENDING";

        const { username, password, serverIP } = this;
        if (username && password && serverIP) {
          this.vuexUpdatePointType("");
          this.vuexUpdatePointProjectName("");
          this.vuexUpdatePointObjectName("");
          this.vuexUpdatePointSerialNumber("");

          this.login({ username, password, serverIP });
        }

        setTimeout(() => {
          this.submitStatus = "OK";
        }, 500);
      }
    },
  },
  beforeDestroy: function () {
    window.removeEventListener("keyup", this.onKeyUp);

    /*     if (this.timer != null) {
      clearInterval(this.timer);
    } */
  },
  watch: {
    $route(to, from) {
      // clear alert on location change
      this.clearAlert();
    },
  },
};
</script>

<style scoped>
.v-list {
  height: 200px; /* or any height you want */
  overflow-y: auto;
}
</style>
